module.exports = __webpack_public_path__ + "img/checkbox_active.fa9760c2.svg";